import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useRef } from "react";
import { GridSortItem } from "@mui/x-data-grid";
import {
  DGT_Pagination,
  asPaginatedContent,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../utils/utils";
import { InsurancePlan, InsurancePlanControllerApi } from "../../services";
import { Identified } from "../../types/sdk-types";

interface Params {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  searchKey?: string;
  status?: boolean | undefined;
  xTENANTID?: string;
  payerId?: string;
}

//       page?: number,
//       size?: number,
//       sortBy?: string,
//       sort?: string,
//       payerId?: string,
//       status?: boolean,
//       archive?: boolean,
//       xTENANTID?: string,

/**
 * @author Atish Bagate
 */
export function useGetAllInsurancePlan({
  gridSorting,
  pagination,
  xTENANTID,
  status,
  payerId,
}: Params): useBaseContent<Identified<InsurancePlan>> {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    prevPage,
  });

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "name" : undefined;

  return useQuery({
    queryKey: [
      "get-all-insurance-plan",
      pagination.pageSize,
      pageIndex,
      xTENANTID,
      status,
      gridSorting,
      payerId,
    ],
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      return new InsurancePlanControllerApi(getConfigObject())
        .getPatientInsurancePlan(
          pageIndex, //page
          pagination.pageSize, //size
          sortBy, // sortBy
          sortDirect, // sortDirection
          payerId, // payerId,
          status as boolean, //status
          false, // archive
          xTENANTID //xTENANTID
        )
        .then((res) =>
          asPaginatedContent<Identified<InsurancePlan>>(res?.data)
        );
    },
  });
}
